import * as CookieConsent from "vanilla-cookieconsent";

export function initCookieConsent(iframeManager, translations, lang) {
  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom left",
      },
      preferencesModal: {
        layout: "box",
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      media: {
        enabled: false,
        readOnly: false,
        services: {
          youtube: {
            label: "YouTube",
            onAccept: () => iframeManager.acceptService("youtube"),
            onReject: () => iframeManager.rejectService("youtube"),
          },
          vimeo: {
            label: "Vimeo",
            onAccept: () => iframeManager.acceptService("vimeo"),
            onReject: () => iframeManager.rejectService("vimeo"),
          },
          arnes: {
            label: "Arnes Video",
            onAccept: () => iframeManager.acceptService("arnes"),
            onReject: () => iframeManager.rejectService("arnes"),
          },
        },
      },
    },

    language: {
      default: lang,
      autoDetect: "document",
      translations: {
        [lang]: {
          consentModal: translations.consentModal,
          preferencesModal: {
            title: translations.preferencesModal.title,
            acceptAllBtn: translations.preferencesModal.acceptAllBtn,
            acceptNecessaryBtn: translations.preferencesModal.acceptNecessaryBtn,
            savePreferencesBtn: translations.preferencesModal.savePreferencesBtn,
            sections: [
              {
                title: translations.preferencesModal.sections.necessary.title,
                description:
                  translations.preferencesModal.sections.necessary.description,
                linkedCategory: "necessary",
              },
              {
                title: translations.preferencesModal.sections.media.title,
                description:
                  translations.preferencesModal.sections.media.description,
                linkedCategory: "media",
              },
            ],
          },
        },
      },
    },
  });
}
